import { globalStyle, style, styleVariants } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { brightTokens } from '@/shared/ui/tokens';

/*
 * 숫자 옆 ⓘ — 글자와 세로 가운데를 맞추고, 24px 박스(xs)가 줄 높이를 밀지 않게 위아래를 걷는다.
 * 모바일 탭 영역(44px)은 IconButton 이 박스 밖으로 넓혀 준다(IconButton.css sizeVariant).
 */
export const trigger = style({
  verticalAlign: 'middle',
  marginBlock: -4,
  marginInlineStart: vars.spacing.gap.xs,
  color: vars.typography.textColor.tertiary,
});

/*
 * 박스는 xs(24px) 로 작게 두고 글리프만 옆 글자(fontSize.sm)와 같은 14px 로 키운다(박인혜 2026-10-13).
 * IconButton 은 크기별 글리프를 `.glyph svg` 로 고정하므로 클래스를 두 번 겹쳐 그보다 세게 건다.
 */
globalStyle(`${trigger}${trigger} svg`, { width: 14, height: 14 });

/* 팀 운영 「집계 기준 보기」(TeamOpsConsole basisNote)와 같은 불투명 덮개 */
export const panel = style({
  position: 'fixed',
  zIndex: vars.elevation.popover,
  minWidth: 240,
  margin: 0,
  padding: vars.spacing.padding.sm,
  borderRadius: vars.spacing.borderRadius.md,
  border: `1px solid ${vars.surface.border.secondary}`,
  background: vars.surface.background.opaque,
  fontSize: vars.typography.fontSize['2xs'],
  lineHeight: vars.typography.lineHeight.normal,
  color: vars.typography.textColor.secondary,
});

export const title = style({
  margin: 0,
  marginBottom: vars.spacing.gap.xs,
  fontSize: vars.typography.fontSize.xs,
  fontWeight: String(vars.typography.fontWeight.semibold),
  color: vars.typography.textColor.primary,
});

export const note = style({
  margin: 0,
  marginBottom: vars.spacing.gap.xs,
});

export const table = style({
  width: '100%',
  borderCollapse: 'collapse',
  fontVariantNumeric: 'tabular-nums',
});

// 표의 글자는 모두 왼쪽 정렬(박인혜 2026-10-13).
export const cell = style({
  padding: `2px ${vars.spacing.gap.xs}`,
  textAlign: 'left',
  whiteSpace: 'nowrap',
});

export const headCell = style([
  cell,
  {
    color: vars.typography.textColor.tertiary,
    fontWeight: String(vars.typography.fontWeight.regular),
  },
]);

export const levelHead = headCell;

export const levelCell = style([cell, { fontWeight: String(vars.typography.fontWeight.regular) }]);

/* 등급 이름 색 — 난이도 태그(DifficultySelect triggerSelected)와 같은 등급색 */
export const levelColor = styleVariants({
  COMMON: { color: brightTokens.rarity.common },
  UNCOMMON: { color: brightTokens.rarity.uncommon },
  RARE: { color: brightTokens.rarity.rare },
  EPIC: { color: brightTokens.rarity.epic },
  LEGENDARY: { color: brightTokens.rarity.legendary },
});

export const currentRow = style({
  color: vars.typography.textColor.primary,
  fontWeight: String(vars.typography.fontWeight.semibold),
});

export const footer = style({
  margin: 0,
  marginTop: vars.spacing.gap.xs,
});
